// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --f_t_font_family_serif: nantes, georgia, serif;
  --f_t_font_family_sans: graphik, helvetica, sans-serif;
  --f_t_font_weight_200: 200;
  --f_t_font_weight_400: 400;
  --f_t_font_weight_500: 500;
  --f_t_font_weight_700: 700;
  --f_t_font_size_12: 12px;
  --f_t_font_size_14: 14px;
  --f_t_font_size_18: 18px;
  --f_t_font_size_22: 22px;
  --f_t_font_size_30: 30px;
  --f_t_font_size_38: 38px;
  --f_t_font_size_52: 52px;
  --f_t_font_size_72: 72px;
  --f_t_line_height_16: 16px;
  --f_t_line_height_20: 20px;
  --f_t_line_height_26: 26px;
  --f_t_line_height_32: 32px;
  --f_t_line_height_38: 38px;
  --f_t_line_height_50: 50px;
  --f_t_line_height_64: 64px;
  --f_t_line_height_86: 86px;
  --f_t_letter_spacing_0: 0;
  --f_t_letter_spacing_0_15: 0.15px;
}

.f_t_base {
  margin: 0;
  padding: 0;
}

.f_t_color {
  color: var(--f_t_color);
}

.f_t_inheritColor {
  color: inherit;
}

.f_t_maxLines {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: var(--f_t_maxLines);
  -webkit-line-clamp: var(--f_t_maxLines);
  max-height: var(--f_t_maxHeight);
}

.f_t_truncate {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.f_t_strikethrough {
  text-decoration: line-through;
}

.f_t_underline {
  text-decoration: underline;
  text-underline-offset: 0.25rem;
}

.f_t_dottedUnderline {
  text-underline-offset: 0.25rem;
  text-decoration-line: underline;
  -webkit-text-decoration-line: underline;
  text-decoration-color: var(--f_t_decorationColor);
  -webkit-text-decoration-color: var(--f_t_decorationColor);
  text-decoration-style: dotted;
  -webkit-text-decoration-style: dotted;
}

.f_t_single_value_text_align {
  text-align: var(--f_t_text_align_mobile);
}

.f_t_variable_text_align {
  text-align: var(--f_t_text_align_mobile);
}

@media screen and (min-width: 768px) {
  .f_t_variable_text_align {
    text-align: var(--f_t_text_align_tablet);
  }
}

@media screen and (min-width: 1024px) {
  .f_t_variable_text_align {
    text-align: var(--f_t_text_align_desktop);
  }
}

@media screen and (min-width: 1440px) {
  .f_t_variable_text_align {
    text-align: var(--f_t_text_align_xlarge);
  }
}

@media screen and (min-width: 1920px) {
  .f_t_variable_text_align {
    text-align: var(--f_t_text_align_xxlarge);
  }
}

.f_t_displayXLSerifRegular {
  font-family: var(
    --slate-xp_typography-family-serif,
    var(--f_t_font_family_serif)
  );
  font-weight: var(--f_t_font_weight_400);
  font-size: var(--f_t_font_size_72);
  line-height: var(--f_t_line_height_86);
  letter-spacing: var(--f_t_letter_spacing_0);
}

.f_t_displayLSerifRegular {
  font-family: var(
    --slate-xp_typography-family-serif,
    var(--f_t_font_family_serif)
  );
  font-weight: var(--f_t_font_weight_400);
  font-size: var(--f_t_font_size_52);
  line-height: var(--f_t_line_height_64);
  letter-spacing: var(--f_t_letter_spacing_0);
}

.f_t_displayMSerifRegular {
  font-family: var(
    --slate-xp_typography-family-serif,
    var(--f_t_font_family_serif)
  );
  font-weight: var(--f_t_font_weight_400);
  font-size: var(--f_t_font_size_38);
  line-height: var(--f_t_line_height_50);
  letter-spacing: var(--f_t_letter_spacing_0);
}

.f_t_displaySSerifRegular {
  font-family: var(
    --slate-xp_typography-family-serif,
    var(--f_t_font_family_serif)
  );
  font-weight: var(--f_t_font_weight_400);
  font-size: var(--f_t_font_size_30);
  line-height: var(--f_t_line_height_38);
  letter-spacing: var(--f_t_letter_spacing_0);
}

.f_t_displaySSansRegular {
  font-family: var(
    --slate-xp_typography-family-sans-serif,
    var(--f_t_font_family_sans)
  );
  font-weight: var(
    --slate-xp_typography-weight-display-s,
    var(--f_t_font_weight_200)
  );
  font-size: var(--f_t_font_size_30);
  line-height: var(--f_t_line_height_38);
  letter-spacing: var(
    --slate-xp_typography-letter-spacing-200,
    var(--f_t_letter_spacing_0_15)
  );
}

.f_t_displaySSansSemiBold {
  font-family: var(
    --slate-xp_typography-family-sans-serif,
    var(--f_t_font_family_sans)
  );
  font-weight: var(
    --slate-xp_typography-weight-display-s-semibold,
    var(--f_t_font_weight_700)
  );
  font-size: var(--f_t_font_size_30);
  line-height: var(--f_t_line_height_38);
  letter-spacing: var(
    --slate-xp_typography-letter-spacing-200,
    var(--f_t_letter_spacing_0_15)
  );
}

.f_t_pageHeaderSerifRegular {
  font-family: var(
    --slate-xp_typography-family-serif,
    var(--f_t_font_family_serif)
  );
  font-weight: var(--f_t_font_weight_400);
  font-size: var(--f_t_font_size_22);
  line-height: var(--f_t_line_height_32);
  letter-spacing: var(--f_t_letter_spacing_0);
}

.f_t_sectionHeaderSansMedium {
  font-family: var(
    --slate-xp_typography-family-sans-serif,
    var(--f_t_font_family_sans)
  );
  font-weight: var(
    --slate-xp_typography-weight-section-heading,
    var(--f_t_font_weight_400)
  );
  font-size: var(--f_t_font_size_22);
  line-height: var(--f_t_line_height_32);
  letter-spacing: var(
    --slate-xp_typography-letter-spacing-200,
    var(--f_t_letter_spacing_0_15)
  );
}

.f_t_subheadingSansMedium {
  font-family: var(
    --slate-xp_typography-family-sans-serif,
    var(--f_t_font_family_sans)
  );
  font-weight: var(
    --slate-xp_typography-weight-subheading-medium,
    var(--f_t_font_weight_500)
  );
  font-size: var(--f_t_font_size_18);
  line-height: var(--f_t_line_height_26);
  letter-spacing: var(
    --slate-xp_typography-letter-spacing-200,
    var(--f_t_letter_spacing_0_15)
  );
}

.f_t_subheadingSansRegular {
  /* --font-weight-medium is overridden for non-medium version of variant w/ medium version's font-weight value to support descendent .font-medium className w/ experimental variant-specific font-weights */
  --font-weight-medium: var(
    --slate-xp_typography-weight-subheading-medium,
    var(--f_t_font_weight_500)
  );
  font-family: var(
    --slate-xp_typography-family-sans-serif,
    var(--f_t_font_family_sans)
  );
  font-weight: var(
    --slate-xp_typography-weight-subheading,
    var(--f_t_font_weight_200)
  );
  font-size: var(--f_t_font_size_18);
  line-height: var(--f_t_line_height_26);
  letter-spacing: var(
    --slate-xp_typography-letter-spacing-200,
    var(--f_t_letter_spacing_0_15)
  );
}

.f_t_paragraphSansMedium {
  font-family: var(
    --slate-xp_typography-family-sans-serif,
    var(--f_t_font_family_sans)
  );
  font-weight: var(
    --slate-xp_typography-weight-paragraph-medium,
    var(--f_t_font_weight_500)
  );
  font-size: var(--f_t_font_size_14);
  line-height: var(--f_t_line_height_20);
  letter-spacing: var(
    --slate-xp_typography-letter-spacing-200,
    var(--f_t_letter_spacing_0_15)
  );
}

.f_t_paragraphSansRegular {
  /* --font-weight-medium is overridden for non-medium version of variant w/ medium version's font-weight value to support descendent .font-medium className w/ experimental variant-specific font-weights */
  --font-weight-medium: var(
    --slate-xp_typography-weight-paragraph-medium,
    var(--f_t_font_weight_500)
  );
  font-family: var(
    --slate-xp_typography-family-sans-serif,
    var(--f_t_font_family_sans)
  );
  font-weight: var(
    --slate-xp_typography-weight-paragraph,
    var(--f_t_font_weight_200)
  );
  font-size: var(--f_t_font_size_14);
  line-height: var(--f_t_line_height_20);
  letter-spacing: var(
    --slate-xp_typography-letter-spacing-200,
    var(--f_t_letter_spacing_0_15)
  );
}

.f_t_labelSansRegular {
  /* --font-weight-medium is overridden for non-medium version of variant w/ medium version's font-weight value to support descendent .font-medium className w/ experimental variant-specific font-weights */
  --font-weight-medium: var(
    --slate-xp_typography-weight-label-medium,
    var(--f_t_font_weight_500)
  );
  font-family: var(
    --slate-xp_typography-family-label,
    var(--slate-xp_typography-family-sans-serif, var(--f_t_font_family_sans))
  );
  font-weight: var(
    --slate-xp_typography-weight-label,
    var(--f_t_font_weight_200)
  );
  font-size: var(--f_t_font_size_12);
  line-height: var(--f_t_line_height_16);
  letter-spacing: var(
    --slate-xp_typography-letter-spacing-200,
    var(--f_t_letter_spacing_0_15)
  );
}

.f_t_labelSansMedium {
  font-family: var(
    --slate-xp_typography-family-label,
    var(--slate-xp_typography-family-sans-serif, var(--f_t_font_family_sans))
  );
  font-weight: var(
    --slate-xp_typography-weight-label-medium,
    var(--f_t_font_weight_500)
  );
  font-size: var(--f_t_font_size_12);
  line-height: var(--f_t_line_height_16);
  letter-spacing: var(
    --slate-xp_typography-letter-spacing-200,
    var(--f_t_letter_spacing_0_15)
  );
}
`, "",{"version":3,"sources":["webpack://./../../core/web/src/slate/Typography/native-styles.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,sDAAsD;EACtD,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,uCAAuC;EACvC,iDAAiD;EACjD,yDAAyD;EACzD,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;;;GAGC;EACD,uCAAuC;EACvC,kCAAkC;EAClC,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE;;;GAGC;EACD,uCAAuC;EACvC,kCAAkC;EAClC,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE;;;GAGC;EACD,uCAAuC;EACvC,kCAAkC;EAClC,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE;;;GAGC;EACD,uCAAuC;EACvC,kCAAkC;EAClC,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE;;;GAGC;EACD;;;GAGC;EACD,kCAAkC;EAClC,sCAAsC;EACtC;;;GAGC;AACH;;AAEA;EACE;;;GAGC;EACD;;;GAGC;EACD,kCAAkC;EAClC,sCAAsC;EACtC;;;GAGC;AACH;;AAEA;EACE;;;GAGC;EACD,uCAAuC;EACvC,kCAAkC;EAClC,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE;;;GAGC;EACD;;;GAGC;EACD,kCAAkC;EAClC,sCAAsC;EACtC;;;GAGC;AACH;;AAEA;EACE;;;GAGC;EACD;;;GAGC;EACD,kCAAkC;EAClC,sCAAsC;EACtC;;;GAGC;AACH;;AAEA;EACE,0MAA0M;EAC1M;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD,kCAAkC;EAClC,sCAAsC;EACtC;;;GAGC;AACH;;AAEA;EACE;;;GAGC;EACD;;;GAGC;EACD,kCAAkC;EAClC,sCAAsC;EACtC;;;GAGC;AACH;;AAEA;EACE,0MAA0M;EAC1M;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD,kCAAkC;EAClC,sCAAsC;EACtC;;;GAGC;AACH;;AAEA;EACE,0MAA0M;EAC1M;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD,kCAAkC;EAClC,sCAAsC;EACtC;;;GAGC;AACH;;AAEA;EACE;;;GAGC;EACD;;;GAGC;EACD,kCAAkC;EAClC,sCAAsC;EACtC;;;GAGC;AACH","sourcesContent":[":root {\n  --f_t_font_family_serif: nantes, georgia, serif;\n  --f_t_font_family_sans: graphik, helvetica, sans-serif;\n  --f_t_font_weight_200: 200;\n  --f_t_font_weight_400: 400;\n  --f_t_font_weight_500: 500;\n  --f_t_font_weight_700: 700;\n  --f_t_font_size_12: 12px;\n  --f_t_font_size_14: 14px;\n  --f_t_font_size_18: 18px;\n  --f_t_font_size_22: 22px;\n  --f_t_font_size_30: 30px;\n  --f_t_font_size_38: 38px;\n  --f_t_font_size_52: 52px;\n  --f_t_font_size_72: 72px;\n  --f_t_line_height_16: 16px;\n  --f_t_line_height_20: 20px;\n  --f_t_line_height_26: 26px;\n  --f_t_line_height_32: 32px;\n  --f_t_line_height_38: 38px;\n  --f_t_line_height_50: 50px;\n  --f_t_line_height_64: 64px;\n  --f_t_line_height_86: 86px;\n  --f_t_letter_spacing_0: 0;\n  --f_t_letter_spacing_0_15: 0.15px;\n}\n\n.f_t_base {\n  margin: 0;\n  padding: 0;\n}\n\n.f_t_color {\n  color: var(--f_t_color);\n}\n\n.f_t_inheritColor {\n  color: inherit;\n}\n\n.f_t_maxLines {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-clamp: var(--f_t_maxLines);\n  -webkit-line-clamp: var(--f_t_maxLines);\n  max-height: var(--f_t_maxHeight);\n}\n\n.f_t_truncate {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.f_t_strikethrough {\n  text-decoration: line-through;\n}\n\n.f_t_underline {\n  text-decoration: underline;\n  text-underline-offset: 0.25rem;\n}\n\n.f_t_dottedUnderline {\n  text-underline-offset: 0.25rem;\n  text-decoration-line: underline;\n  -webkit-text-decoration-line: underline;\n  text-decoration-color: var(--f_t_decorationColor);\n  -webkit-text-decoration-color: var(--f_t_decorationColor);\n  text-decoration-style: dotted;\n  -webkit-text-decoration-style: dotted;\n}\n\n.f_t_single_value_text_align {\n  text-align: var(--f_t_text_align_mobile);\n}\n\n.f_t_variable_text_align {\n  text-align: var(--f_t_text_align_mobile);\n}\n\n@media screen and (min-width: 768px) {\n  .f_t_variable_text_align {\n    text-align: var(--f_t_text_align_tablet);\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .f_t_variable_text_align {\n    text-align: var(--f_t_text_align_desktop);\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .f_t_variable_text_align {\n    text-align: var(--f_t_text_align_xlarge);\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .f_t_variable_text_align {\n    text-align: var(--f_t_text_align_xxlarge);\n  }\n}\n\n.f_t_displayXLSerifRegular {\n  font-family: var(\n    --slate-xp_typography-family-serif,\n    var(--f_t_font_family_serif)\n  );\n  font-weight: var(--f_t_font_weight_400);\n  font-size: var(--f_t_font_size_72);\n  line-height: var(--f_t_line_height_86);\n  letter-spacing: var(--f_t_letter_spacing_0);\n}\n\n.f_t_displayLSerifRegular {\n  font-family: var(\n    --slate-xp_typography-family-serif,\n    var(--f_t_font_family_serif)\n  );\n  font-weight: var(--f_t_font_weight_400);\n  font-size: var(--f_t_font_size_52);\n  line-height: var(--f_t_line_height_64);\n  letter-spacing: var(--f_t_letter_spacing_0);\n}\n\n.f_t_displayMSerifRegular {\n  font-family: var(\n    --slate-xp_typography-family-serif,\n    var(--f_t_font_family_serif)\n  );\n  font-weight: var(--f_t_font_weight_400);\n  font-size: var(--f_t_font_size_38);\n  line-height: var(--f_t_line_height_50);\n  letter-spacing: var(--f_t_letter_spacing_0);\n}\n\n.f_t_displaySSerifRegular {\n  font-family: var(\n    --slate-xp_typography-family-serif,\n    var(--f_t_font_family_serif)\n  );\n  font-weight: var(--f_t_font_weight_400);\n  font-size: var(--f_t_font_size_30);\n  line-height: var(--f_t_line_height_38);\n  letter-spacing: var(--f_t_letter_spacing_0);\n}\n\n.f_t_displaySSansRegular {\n  font-family: var(\n    --slate-xp_typography-family-sans-serif,\n    var(--f_t_font_family_sans)\n  );\n  font-weight: var(\n    --slate-xp_typography-weight-display-s,\n    var(--f_t_font_weight_200)\n  );\n  font-size: var(--f_t_font_size_30);\n  line-height: var(--f_t_line_height_38);\n  letter-spacing: var(\n    --slate-xp_typography-letter-spacing-200,\n    var(--f_t_letter_spacing_0_15)\n  );\n}\n\n.f_t_displaySSansSemiBold {\n  font-family: var(\n    --slate-xp_typography-family-sans-serif,\n    var(--f_t_font_family_sans)\n  );\n  font-weight: var(\n    --slate-xp_typography-weight-display-s-semibold,\n    var(--f_t_font_weight_700)\n  );\n  font-size: var(--f_t_font_size_30);\n  line-height: var(--f_t_line_height_38);\n  letter-spacing: var(\n    --slate-xp_typography-letter-spacing-200,\n    var(--f_t_letter_spacing_0_15)\n  );\n}\n\n.f_t_pageHeaderSerifRegular {\n  font-family: var(\n    --slate-xp_typography-family-serif,\n    var(--f_t_font_family_serif)\n  );\n  font-weight: var(--f_t_font_weight_400);\n  font-size: var(--f_t_font_size_22);\n  line-height: var(--f_t_line_height_32);\n  letter-spacing: var(--f_t_letter_spacing_0);\n}\n\n.f_t_sectionHeaderSansMedium {\n  font-family: var(\n    --slate-xp_typography-family-sans-serif,\n    var(--f_t_font_family_sans)\n  );\n  font-weight: var(\n    --slate-xp_typography-weight-section-heading,\n    var(--f_t_font_weight_400)\n  );\n  font-size: var(--f_t_font_size_22);\n  line-height: var(--f_t_line_height_32);\n  letter-spacing: var(\n    --slate-xp_typography-letter-spacing-200,\n    var(--f_t_letter_spacing_0_15)\n  );\n}\n\n.f_t_subheadingSansMedium {\n  font-family: var(\n    --slate-xp_typography-family-sans-serif,\n    var(--f_t_font_family_sans)\n  );\n  font-weight: var(\n    --slate-xp_typography-weight-subheading-medium,\n    var(--f_t_font_weight_500)\n  );\n  font-size: var(--f_t_font_size_18);\n  line-height: var(--f_t_line_height_26);\n  letter-spacing: var(\n    --slate-xp_typography-letter-spacing-200,\n    var(--f_t_letter_spacing_0_15)\n  );\n}\n\n.f_t_subheadingSansRegular {\n  /* --font-weight-medium is overridden for non-medium version of variant w/ medium version's font-weight value to support descendent .font-medium className w/ experimental variant-specific font-weights */\n  --font-weight-medium: var(\n    --slate-xp_typography-weight-subheading-medium,\n    var(--f_t_font_weight_500)\n  );\n  font-family: var(\n    --slate-xp_typography-family-sans-serif,\n    var(--f_t_font_family_sans)\n  );\n  font-weight: var(\n    --slate-xp_typography-weight-subheading,\n    var(--f_t_font_weight_200)\n  );\n  font-size: var(--f_t_font_size_18);\n  line-height: var(--f_t_line_height_26);\n  letter-spacing: var(\n    --slate-xp_typography-letter-spacing-200,\n    var(--f_t_letter_spacing_0_15)\n  );\n}\n\n.f_t_paragraphSansMedium {\n  font-family: var(\n    --slate-xp_typography-family-sans-serif,\n    var(--f_t_font_family_sans)\n  );\n  font-weight: var(\n    --slate-xp_typography-weight-paragraph-medium,\n    var(--f_t_font_weight_500)\n  );\n  font-size: var(--f_t_font_size_14);\n  line-height: var(--f_t_line_height_20);\n  letter-spacing: var(\n    --slate-xp_typography-letter-spacing-200,\n    var(--f_t_letter_spacing_0_15)\n  );\n}\n\n.f_t_paragraphSansRegular {\n  /* --font-weight-medium is overridden for non-medium version of variant w/ medium version's font-weight value to support descendent .font-medium className w/ experimental variant-specific font-weights */\n  --font-weight-medium: var(\n    --slate-xp_typography-weight-paragraph-medium,\n    var(--f_t_font_weight_500)\n  );\n  font-family: var(\n    --slate-xp_typography-family-sans-serif,\n    var(--f_t_font_family_sans)\n  );\n  font-weight: var(\n    --slate-xp_typography-weight-paragraph,\n    var(--f_t_font_weight_200)\n  );\n  font-size: var(--f_t_font_size_14);\n  line-height: var(--f_t_line_height_20);\n  letter-spacing: var(\n    --slate-xp_typography-letter-spacing-200,\n    var(--f_t_letter_spacing_0_15)\n  );\n}\n\n.f_t_labelSansRegular {\n  /* --font-weight-medium is overridden for non-medium version of variant w/ medium version's font-weight value to support descendent .font-medium className w/ experimental variant-specific font-weights */\n  --font-weight-medium: var(\n    --slate-xp_typography-weight-label-medium,\n    var(--f_t_font_weight_500)\n  );\n  font-family: var(\n    --slate-xp_typography-family-label,\n    var(--slate-xp_typography-family-sans-serif, var(--f_t_font_family_sans))\n  );\n  font-weight: var(\n    --slate-xp_typography-weight-label,\n    var(--f_t_font_weight_200)\n  );\n  font-size: var(--f_t_font_size_12);\n  line-height: var(--f_t_line_height_16);\n  letter-spacing: var(\n    --slate-xp_typography-letter-spacing-200,\n    var(--f_t_letter_spacing_0_15)\n  );\n}\n\n.f_t_labelSansMedium {\n  font-family: var(\n    --slate-xp_typography-family-label,\n    var(--slate-xp_typography-family-sans-serif, var(--f_t_font_family_sans))\n  );\n  font-weight: var(\n    --slate-xp_typography-weight-label-medium,\n    var(--f_t_font_weight_500)\n  );\n  font-size: var(--f_t_font_size_12);\n  line-height: var(--f_t_line_height_16);\n  letter-spacing: var(\n    --slate-xp_typography-letter-spacing-200,\n    var(--f_t_letter_spacing_0_15)\n  );\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
